import React, { Component } from 'react';
import Box from '../ui/Box';
import { Dialog } from 'material-ui';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import Toggle from 'react-toggle';
import Select, { Async } from 'react-select'
import Slider from 'material-ui/Slider';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import Helper from '../../services/Helper';
var help = Helper;

export default class NewScene extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.details ? this.props.details.sceneName : "",
            all_switches: [],
            pre_room_id: this.props.room_main_id,
            switches_loading: true,
            dialog: {
                open: false,
                head: 'Dude',
                body: 'This is working',
                actions: [
                    <FlatButton
                        label="Okay"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            }
        }
    }

    componentDidMount() {
        this.getAllSwitches();
    }

    getAllSwitches() {
        this.setState({
            switches_loading: true
        });
        ds.getSwitchesInRoom(this.state.pre_room_id, data => {
            this.setState({
                all_switches: data.switchAppliances,
                switches_loading: false
            })
            if (this.props.details && this.props.details._id) {
                let edit_actions = {};
                for (let i of this.props.details.actions) {
                    edit_actions[i.switch_appliance_id] = i;
                }
                let x = this.state.all_switches;
                for (let i of x) {
                    if (edit_actions[i._id]) {
                        i.selected = true;
                        i.selected_state = edit_actions[i._id].switch_state;
                        i.selected_state_dimmer = edit_actions[i._id].dimm_value;
                    }
                }
                this.setState({
                    all_switches: x
                })
            }
        }, err => {
            this.setState({
                switches_loading: false
            });
        })
    }

    closeDialog() {
        this.setState({
            dialog: {
                head: '',
                body: '',
                open: false,
                actions: []
            }
        })

    }


    createScene(e) {
        e.preventDefault();
        let actions = this.constructActions();
        if (!this.state.name || !actions.length) {
            this.setState({
                dialog: {
                    open: true,
                    head: 'Invalid',
                    body: 'All Fields are mandatory',
                    actions: [
                        <FlatButton
                            label="Okay"
                            primary
                            onClick={this.closeDialog.bind(this)}
                        />
                    ]
                }
            })
        }
        else {
            let payload;
            payload = {
                sceneName: this.state.name,
                room_id: this.state.pre_room_id,
                actions
            };
            if (this.props.details) {
                ds.postEditScene({ ...payload, _id: this.props.details._id }, data => {
                    let evt = new CustomEvent('updateScenesTable', { detail: true });
                    window.dispatchEvent(evt);
                    this.props.unMountMe();
                }, err => {

                })
            }
            else {
                ds.postCreateScene(payload, data => {
                    let evt = new CustomEvent('updateScenesTable', { detail: true });
                    window.dispatchEvent(evt);
                    let {all_switches} = this.state;
                    for (let i of all_switches) {
                        i.selected = false;
                        i.selected_state = false;
                    }
                    this.setState({
                        name: "",
                        all_switches
                    })
                }, err => {

                })
            }
        }

    }

    constructActions() {
        let actions = [];
        for (let i of this.state.all_switches) {
            if (i.selected) {

                actions.push({
                    UDid: i.UDid,
                    actionType: "switchAction",
                    switch_no: i.switch_no,
                    switch_state: i.selected_state ? true : false,
                    act_type: "switch",
                    key: new Date().getTime(),
                    mobId: "yolo",
                    switch_appliance_id: i._id
                })

                if (i.switch_type == "regulator" && i.selected_state) {
                    actions.push({
                        UDid: i.UDid,
                        actionType: "switchAction",
                        switch_no: i.switch_no,
                        switch_state: i.selected_state,
                        act_type: "regulate",
                        key: new Date().getTime(),
                        mobId: "yolo",
                        switch_appliance_id: i._id,
                        dimm_value: i.selected_state_dimmer
                    })
                }
            }
        }
        return actions;
    }

    handleChanges(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {
        return (
            <Box header={this.props.details && this.props.details._id ? 'Edit Scene' : 'New Scene'}>
                <Dialog
                    title={this.state.dialog.head}
                    actions={this.state.dialog.actions}
                    modal={false}
                    open={this.state.dialog.open}
                    onRequestClose={this.closeDialog.bind(this)}
                >
                    {this.state.dialog.body || 'NA'}
                </Dialog>
                <div className="col-sm-12">
                    <form className="smart-form " onSubmit={this.createScene.bind(this)}>
                        {this.state.all_switches && this.state.all_switches.length && !this.state.switches_loading ?
                            <fieldset>

                                <section>
                                    <TextField
                                        floatingLabelText="Name"
                                        name="name"
                                        className="w-100"
                                        value={this.state.name}
                                        onChange={this.handleChanges.bind(this)}
                                    />
                                </section>

                                <section style={{ marginTop: "1rem" }}>
                                    Actions</section>
                                <br />
                                {
                                    this.state.all_switches.map((swi, ind) => {
                                        return <section style={{ margin: "1.5rem 0rem" }} className="row" key={ind}>
                                            <div className="col-sm-7 col-7">
                                                <Checkbox label={swi.name} key={ind}
                                                    checked={this.state.all_switches[ind].selected}
                                                    onCheck={
                                                        (e) => {
                                                            let x = this.state.all_switches;
                                                            x[ind].selected = e.target.checked ? true : false;
                                                            this.setState({
                                                                all_switches: x
                                                            })
                                                        }
                                                    } />
                                            </div>
                                            <div className="col-sm-5 col-5">
                                                <Toggle
                                                    onChange={
                                                        (e) => {
                                                            let x = this.state.all_switches;
                                                            x[ind].selected_state = e.target.checked ? true : false;
                                                            this.setState({
                                                                all_switches: x
                                                            })
                                                        }
                                                    }
                                                    icons={{ checked: <span style={{ color: "white" }}>ON</span>, unchecked: <span style={{ color: "white" }}>OFF</span> }}
                                                    checked={this.state.all_switches[ind].selected_state}
                                                />
                                                {/* <span className='label-text'>{this.state.all_switches[ind].selected_state ? "ON" : "OFF"}</span> */}
                                            </div>
                                            {
                                                swi.switch_type == 'regulator' && swi.selected_state && swi.selected ? <div className="col-sm-12" style={{ marginTop: "0.45rem" }}>
                                                    <div id="label" style={{ paddingLeft: "0.5rem" }}>Fan Speed</div>
                                                    <Slider step={20}
                                                        style={{
                                                            marginTop: "-1rem",
                                                            padding: "0rem 0.5rem"
                                                        }}
                                                        aria-labelledby="label"
                                                        onChange={
                                                            (e, v) => {
                                                                let x = this.state.all_switches;
                                                                x[ind].selected_state_dimmer = v == 100 ? 99 : v;
                                                                this.setState({
                                                                    all_switches: x
                                                                })
                                                            }
                                                        } min={0} max={100} value={this.state.all_switches[ind].selected_state_dimmer} /></div> : null
                                            }
                                        </section>
                                    })
                                }



                            </fieldset> : <div>No Switches Available in the room to create a scene</div>}

                        <div className="mt-4vw align-right">
                            <RaisedButton
                                label="Save"
                                primary
                                type="submit"
                            />
                            <span className="space"></span>
                            {
                                this.props.details ?
                                    <FlatButton
                                        label="Cancel"
                                        primary
                                        onClick={this.props.unMountMe.bind(this, false)}
                                        type="button"
                                    /> : null
                            }
                        </div>
                    </form>

                </div>
            </Box>)
    }
}


// WEBPACK FOOTER //
// ./components/scenes/NewScene.js